import axios from 'axios';
import Micromodal from 'micromodal';
import { FC, useEffect, useState } from 'react';
import { getModalOption, Setting, Subscription, SubscriptionLine } from '../../App';
import { CUSTOMER_API_URL } from '../../constants';
import { SpinButton } from '../SpinButton';

import base from '../../styles/Base.module.css';
import style from '../../styles/SubscriptionDetail.module.css';

export const ChangeQuantity: FC<{
  subscriptionContactId: string;
  line: SubscriptionLine;
  setting: Setting;
  updateSubscription: () => Promise<void> | void;
  updateLine: (lineId: string, updatedLine: SubscriptionLine) => void;
  removeLine: (lineId: string) => void;
  onComplete?: (message?: string) => void;
}> = ({ subscriptionContactId, line, setting, updateSubscription, updateLine, removeLine, onComplete }) => {
  const [subscription, setSubscription] = useState<Subscription>();
  const [quantity, setQuantity] = useState<number>(line.quantity);
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [isProc, setIsProc] = useState<boolean>(false);

  useEffect(() => {
    // MicroModal の初期化
    Micromodal.init();

    axios
      .post(
        `${CUSTOMER_API_URL}?action=getSubscription`,
        {
          subscriptionId: subscriptionContactId,
        },
        { headers: { Authorization: setting.token } },
      )
      .then((response) => {
        setSubscription(response.data);
      });
  }, []);

  if (!subscriptionContactId || !subscription) {
    return <></>;
  }

  const originQuantity = line.quantity;
  const lineId = line.lineId;

  // 変更ボタンをクリックした際の挙動
  // --------------------------------------------
  const onClickQuantityModify = async () => {
    setIsProc(true);

    console.log({ line });
    // console.log({quantity});

    if (quantity === 0) {
      //   // 0の場合は削除
      try {
        await axios
          .post(
            `${CUSTOMER_API_URL}?action=removeSubscriptionLine`,
            {
              subscriptionId: subscriptionContactId,
              subscriptionLine: line,
            },
            {
              headers: { Authorization: setting.token },
            },
          )
          .then((response) => {
            console.log({ response });
            removeLine(line.lineId);
            if (onComplete) {
              onComplete('商品を削除しました');
            } else {
              window.parent.postMessage({ action: 'completeRemoveQuantity' }, '*');
            }
          });
      } catch (e) {
        console.log(e);
        Micromodal.show('modal-error', getModalOption(setting));
        setIsProc(false);
        return;
      }
    } else {
      try {
        await axios
          .post(
            `${CUSTOMER_API_URL}?action=updateSubscriptionLine`,
            {
              subscriptionId: subscriptionContactId,
              // variantId: line.variantId,
              // planId,
              lineId,
              quantity,
            },
            {
              headers: { Authorization: setting.token },
            },
          )
          .then((response) => {
            console.log({ response });
            // 既存の行データの数量だけ更新（responseのcurrentPriceAmountはライン合計の可能性があるため使わない）
            const updatedLine = { ...line, quantity };
            // ローカルstateを更新
            setSubscription({
              ...subscription!,
              subscriptionLines: subscription!.subscriptionLines.map((l) => {
                if (l.lineId !== line.lineId) {
                  return l;
                }
                return updatedLine;
              }),
            });
            // 親のsubscription stateを楽観的に更新（API再取得せず即反映）
            updateLine(line.lineId, updatedLine);
            setIsChanged(false);
            if (onComplete) {
              onComplete('数量を更新しました');
            } else {
              window.parent.postMessage({ action: 'completeChangeQuantity' }, '*');
            }
          });
      } catch (e) {
        console.log(e);
        Micromodal.show('modal-error');
        setIsProc(false);
        return;
      }
    }
  };

  // 数量変更ボタンのクリックした時の挙動
  // --------------------------------------------
  const onChangeQuantity = async (e: any) => {
    console.log({ e });
    await setQuantity(e);
    if (e !== originQuantity) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  };

  return (
    <div className={style.productQuantity}>
      <SpinButton min={0} value={quantity} onChange={onChangeQuantity} />
      <button
        className={`${base.sectionBtn} ${style.productQuantityButton} `}
        disabled={!isChanged}
        onClick={onClickQuantityModify}
      >
        {/* {
          isProc ? <Spinner isLoading /> : '変更'
        } */}
        変更
      </button>
    </div>
  );
};
